export const errorConfig = {
    ERROR_IN_SENDING_SMS: 'Failed to send SMS OTP. Please try again.',
    OTP_SEND_LIMIT_EXCEEDED: 'You exceeded the OTP limit. Please try again after 10 minutes.',
    ERROR_IN_SENDING_EMAIL: 'Failed to send email OTP. Please try again.',
    NO_SAVED_OTP_FOUND: 'OTP expired. Please resend OTP and try again.',
    INVALID_OTP: 'Please enter a valid OTP',
    OTP_VALIDATE_LIMIT_EXCEEDED: 'You exceeded the OTP validation limit. Please try again in 10 minutes',
    INVALID_MOBILE: 'Something went wrong. Please try again.',
    default: 'Something went wrong. Please try again.',
    USER_ALREADY_EXISTS_FOR_MOBILE:'Phone number already associated with another account.'
}
